import axios from 'axios'

export const updateProfileData = async (token, updatedUserInput) => {
  const url = process.env.GATSBY_API_LOYALTY_APP

  const headers = {
    Authorization: `Bearer ${token}`,
    withCredentials: false,
    'x-functions-key': process.env.GATSBY_AZURE_FUNCTION_KEY,
    'Access-Control-Allow-Origin': '*'
  }

  const res = await axios({
    method: 'patch',
    headers,
    url,
    data: { op: 'updateProfileData', updatedUserInput }
  })

  return res.data
}
